import type { ConsentDTO } from '@nora-monorepo/nora-api-client';
import { isNonEmptyString } from '@nora-monorepo/shared';
import { i18n as i18nSetup } from '@nora-monorepo/ui-shared';

const { t } = i18nSetup.global;

export function getConsentStatusLabel(consent?: ConsentDTO | null): string {
  if (!consent?.status) {
    return '';
  }

  return t(`consent.status.short.${consent.status.toLowerCase()}`);
}

export function getConsentTitle(consent?: ConsentDTO): string {
  if (!consent) {
    return '';
  }

  return consent.operation?.name ?? consent.id;
}

export function getConsentInvitedByUser(
  consent?: ConsentDTO,
): string | null | undefined {
  if (!consent) {
    return null;
  }

  if (!consent.invitedByUser) {
    return null;
  }
  const user = consent.invitedByUser;
  if (isNonEmptyString(user.displayName)) {
    return user.displayName;
  }

  if (isNonEmptyString(user.firstName) && isNonEmptyString(user.lastName)) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (isNonEmptyString(user.username)) {
    return user.username;
  }

  return isNonEmptyString(user.firstName) ? user.firstName : user.lastName;
}
